import { createContext } from 'react';
import type { FMContext, FMNames } from '../types';

export const returnZero = () => 0;
export const vehicleInfoFormKeys: FMNames[] = [
    'msrp',
    'sellingPrice',
    'invoiceAmount',
    'cost',
    'condition',
    'mileage',
    'wholesaleValue',
    'wholesaleBookSource',
    'wholesaleValueType',
    'stockNumber',
    'cylinders',
    'odometerMileageType',
    'exteriorColor',
    'interiorColor',
    'fuel',
    'engine',
    'transmission',
    'transmissionType',
    'trim',
    'brakingMechanism',
    'steeringMechanism',
    'isAirConditioningIncluded',
    'grossVehicleWeightRating',
    'driveLine',
    'vehicleUse',
    'principalDriverName'
];
export const FormContext = createContext<FMContext>({
    form: { values: {}, initialValues: {}, touched: {}, error: {} },
    canApply: false,
    changeHandler: returnZero,
    handleClick: returnZero,
    hideDrawer: returnZero,
    isStockEditable: false,
    handleClickEditStock: returnZero,
    isTrimEditable: false,
    handleClickEditTrim: returnZero,
    resetEditable: returnZero,
    handleBlur: returnZero
});
